import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { COLORS } from 'new-ui/constants';
import ArrowCircle from 'assets/icons/arrow-circle.svg';
import './Button.css';

const Button = (props) => {
  const {
    backgroundColor,
    color,
    title,
    action,
    width,
    className,
    titleClassName,
    disabled,
    icon,
    svg,
    theme,
    forwardIconArrow = false,
    endIcon,
    customIcon,
    form,
    type = 'button',
    style: styleProp,
  } = props;
  let {
    forwardIcon,
  } = props;
  if (forwardIconArrow) forwardIcon = ArrowCircle;
  const style = {
    backgroundColor: backgroundColor || COLORS.primaryButton,
    color: color || COLORS.primaryButtonText,
    width: width || '100%',
    ...(styleProp ?? {}),
  };

  return (
    <button
      form={form}
      // eslint-disable-next-line react/button-has-type
      type={type}
      className={`button ${className || ''} ${icon && 'icon-button'} ${theme ? `${theme}-theme` : ''} ${forwardIconArrow ? 'icon-arrow' : ''}`}
      style={style}
      onClick={action}
      disabled={disabled}
    >
      {icon ? <img src={icon} alt="icon" /> : null}
      {customIcon || null}
      {svg || null}
      <span className={cx('button-text', titleClassName)}>
        {title}
      </span>
      {forwardIcon ? <img className="forward-icon" src={forwardIcon} alt="icon" /> : null}
      {endIcon ? <img src={endIcon} alt="icon" /> : null}
    </button>
  );
};

Button.propTypes = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  title: PropTypes.string,
  action: PropTypes.func,
  width: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  customIcon: PropTypes.any,
  icon: PropTypes.any,
  svg: PropTypes.any,
  forwardIcon: PropTypes.any,
  forwardIconArrow: PropTypes.any,
  theme: PropTypes.string,
  endIcon: PropTypes.string,
  form: PropTypes.string,
  type: PropTypes.oneOf(['submit', 'reset', 'button']),
  style: PropTypes.object,
};

export default Button;
